import { isNotNullOrUndefined, isNullOrUndefined, stringIsEmpty } from 'Util/TypeGuards';

// Converts a hex colour value to RGB colour value
export function HexToRgb(hex: string) {
	if (stringIsEmpty(hex)) {
		return null;
	}
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16),
			}
		: null;
}

export function HexToRgbString(rgbColour: unknown) {
	if (isNotNullOrUndefined(rgbColour)) {
		const colour = rgbColour as { r: number; g: number; b: number };
		return `${colour.r}, ${colour.g}, ${colour.b}`;
	}
	return '';
}

export function GetRgbColourString(rgbColour: unknown) {
	if (isNotNullOrUndefined(rgbColour)) {
		const colour = rgbColour as { r: number; g: number; b: number };
		const red = colour.r / 255;
		const green = colour.g / 255;
		const blue = colour.b / 255;

		return `${red}, ${green}, ${blue}`;
	}
	return '';
}

export function TextOnBackgroundColour(hex?: string | null) {
	if (isNullOrUndefined(hex) || hex === '') {
		return 'black';
	}

	const c = hex.replace('#', '');
	const r = parseInt(c.substr(0, 2), 16);
	const g = parseInt(c.substr(2, 2), 16);
	const b = parseInt(c.substr(4, 2), 16);

	// Calculate relative luminance
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

	return luminance > 0.6 ? 'black' : 'white';
}
